export default "__VITE_ASSET__Bk8C9HaD__"